import { formatOrAnonymize } from "./format-or-anonymize";

const formatter = new Intl.NumberFormat('de-DE');

export function toPercentString(value?: number | string | null): string {
  const percentageStringOrAnonymized = formatOrAnonymize(value, (value) => formatter.format(+value) + '%');
  return percentageStringOrAnonymized;
}